import {Component, OnInit} from '@angular/core';
import {allLayers} from 'src/app/constants/layer';
import {CommonService} from 'src/app/services/common.service';
import {MapboxGlService} from 'src/app/services/mapbox-gl.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {

  public logo = './assets/images/favicon.png';
  constructor(
    public commonService: CommonService,
    public mapboxglService: MapboxGlService
  ) { }

  ngOnInit(): void {
    this.initMap().then();
  }

  initMap = async () => {
    // Add new map
    await this.mapboxglService.showMap('mapViewDiv', 10, [94.90903297, 27.4805688]);
    this.mapboxglService.mapOnLoadedSubject.subscribe(() => {
      this.mapboxglService.addLayers(allLayers);
      this.mapboxglService.mapFitBounds([[94.5693359375, 27.098739624023438], [95.49100494384766, 27.71263313293457]]);
      this.mapboxglService.addCustomZoomInControl();
      this.mapboxglService.addCustomZoomOutControl();
      this.mapboxglService.addCustomCompassControl();
      this.mapboxglService.addLayerControl();
      this.mapboxglService.addSearchControl();
      this.mapboxglService.addGraphControl();
      this.mapboxglService.addChangeStyleControl();
      this.mapboxglService.addFeatureInfoControl();
      this.mapboxglService.addCustomDrawControl();
    });
  }

}
